/* HDN · Ventana del boletín (sections/hdn-popup-boletin.liquid).
 *
 * - Sale una sola vez, a los N segundos, si no se ha cerrado ni suscrito en los últimos días.
 * - Tras suscribirse (la página vuelve con el formulario enviado) se enseña el «gracias».
 * - Se cierra con la X, «No, gracias», Escape o pulsando fuera; el foco vuelve donde estaba.
 * - En el editor de temas solo sale al seleccionar la sección.
 */
const CLAVE = 'hdn:popup-boletin';

function guardar(dias) {
  try {
    localStorage.setItem(CLAVE, String(Date.now() + dias * 86400000));
  } catch {}
}

function silenciada() {
  try {
    return Number(localStorage.getItem(CLAVE) || 0) > Date.now();
  } catch {
    return false;
  }
}

class HdnPopupBoletin extends HTMLElement {
  connectedCallback() {
    this.dialogo = this.querySelector('dialog');
    if (!this.dialogo) return;
    this.dias = Number(this.dataset.dias) || 30;
    const retraso = (Number(this.dataset.retraso) || 45) * 1000;

    this.dialogo.addEventListener('click', (event) => {
      if (event.target.closest('[data-cerrar]') || event.target === this.dialogo) this.cerrar();
    });
    this.dialogo.addEventListener('close', () => guardar(this.dias));

    if ('editor' in this.dataset) {
      document.addEventListener('shopify:section:select', (e) => { if (this.closest('.shopify-section') === e.target) this.abrir(); });
      document.addEventListener('shopify:section:deselect', (e) => { if (this.closest('.shopify-section') === e.target) this.dialogo.close(); });
      return;
    }

    // Vuelta tras suscribirse: se enseña el agradecimiento y no vuelve a salir.
    const gracias = this.querySelector('[data-suscrito]');
    if (gracias || this.querySelector('[aria-invalid="true"]')) {
      this.abrir();
      gracias?.focus();
      if (gracias) guardar(365);
      return;
    }
    if (silenciada()) return;
    this.temporizador = setTimeout(() => this.abrir(), retraso);
  }

  disconnectedCallback() {
    clearTimeout(this.temporizador);
  }

  abrir() {
    if (this.dialogo.open) return;
    // No se abre encima de otra ventana (carrito, búsqueda, aviso de cookies…).
    if (document.querySelector('dialog[open]:not(.hdn-popup)')) {
      this.temporizador = setTimeout(() => this.abrir(), 10000);
      return;
    }
    this.dialogo.classList.add('hdn-popup');
    this.dialogo.showModal();
  }

  cerrar() {
    this.dialogo.close();
  }
}

if (!customElements.get('hdn-popup-boletin')) customElements.define('hdn-popup-boletin', HdnPopupBoletin);
